import { useCallback, useEffect, useState } from 'react'

import {
  type AuthUser,
  clearStoredUser,
  readStoredUser,
  writeStoredUser,
} from '@/config/auth'

export const AUTH_CHANGED_EVENT = 'minego-auth-changed'

export function useAuth() {
  const [user, setUser] = useState<AuthUser | null>(() =>
    typeof window === 'undefined' ? null : readStoredUser(),
  )

  useEffect(() => {
    const sync = () => setUser(readStoredUser())
    sync()
    window.addEventListener(AUTH_CHANGED_EVENT, sync)
    return () => window.removeEventListener(AUTH_CHANGED_EVENT, sync)
  }, [])

  const logout = useCallback(async () => {
    clearStoredUser()
    setUser(null)
    window.dispatchEvent(new Event(AUTH_CHANGED_EVENT))
  }, [])

  const signInLocal = useCallback((next: AuthUser) => {
    writeStoredUser(next)
    setUser(next)
    window.dispatchEvent(new Event(AUTH_CHANGED_EVENT))
  }, [])

  return {
    user,
    loading: false,
    isAuthenticated: Boolean(user),
    error: null as Error | null,
    logout,
    signInLocal,
    refresh: async () => {
      setUser(readStoredUser())
    },
  }
}
